import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SlickButtonSpinnerModule, SlickDialogModule } from "@slick-components";
import { ReadingsAndDosagesDialogComponent } from "./readings-and-dosages-dialog.component";

// Pulled out of AppointmentsComponentsModule so the Assets tab can host the same dialog without
// dragging in the whole appointments module (and the import cycle that comes with it).
@NgModule({
	imports: [CommonModule, FormsModule, SlickDialogModule, SlickButtonSpinnerModule],
	declarations: [ReadingsAndDosagesDialogComponent],
	exports: [ReadingsAndDosagesDialogComponent]
})
export class ReadingsAndDosagesDialogModule { }
